module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "cb-epub"
    }
  }, [_c('div', {
    staticClass: "generated-style-2"
  }, [_c('h1', {
    staticClass: "chapterhead",
    attrs: {
      "id": "toc-anchor",
      "xml:lang": "en-us"
    }
  }, [_vm._v("2")]), _vm._v(" "), _c('p', {
    staticClass: "chdate",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("Six Months Earlier ")]), _vm._v(" "), _c('p', {
    staticClass: "chdate",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("February 21, 2011")]), _vm._v(" "), _c('p', {
    staticClass: "chfirstpara",
    attrs: {
      "xml:lang": "en-ca"
    }
  }, [_c('span', {
    staticClass: "small-caps"
  }, [_vm._v("DETECTIVE NASTOS OPENED THE DOOR")]), _vm._v(" and walked into the central office of the Sexual Assault Unit. A dozen cops sat at cubicles, ignoring ringing phones on their desks in favour of the tv screen, shouting at the Maple Leafs for losing another hockey game while they sipped their Tim Hortons coffees. Play-by-play commentary was accented by shouts from the detectives filling the room. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("It’s not a crime until it’s overtime,")]), _vm._v(" Nastos said the common police motto to himself. All day you do your important personal stuff, catch the hockey game, visit a girlfriend, avoid your boss, then just before you’re supposed to go home, you find something plausibly urgent — get a witness to come in for a scheduled interview or follow up on a tip you got hours or days ago. By the end of the year, it was an easy way to make a few thousand in overtime. A hockey game was as good an excuse as any because, for full enjoyment, it required assistance from other detectives. ")]), _vm._v(" "), _c('p', {
    staticClass: "textindent",
    attrs: {
      "xml:lang": "en-ca"
    }
  }, [_vm._v("Nastos went to the cubicle farthest from the door in a back corner. He sat at his desk, turned on the table light and flicked the mouse to bring the computer screen to life. It was five in the afternoon and he was beginning his night shift. The phone rang and he picked it up. ")]), _vm._v(" "), _c('p', {
    staticClass: "textindent",
    attrs: {
      "xml:lang": "en-ca"
    }
  }, [_vm._v("“Nastos, Sexual Assault Unit.” With the phone jammed between his ear and shoulder he logged into his email and started deleting junk. ")]), _vm._v(" "), _c('p', {
    staticClass: "textindent",
    attrs: {
      "xml:lang": "en-ca"
    }
  }, [_vm._v("“Yeah, I have all my files here, where else would I keep them? Umm, that one’s not really standing out by name. Yeah, that is pretty gross, but this is the Sexual Assault Unit — all of these stories are disgusting. Those circumstances aren’t really standing out for me. Harper file? What can I say, the guy’s not a productive citizen. Listen, I’ve got four uniforms and a road sergeant helping me with a warrant in an hour to bust that guy. Tell you what, I’ll call back when I’m done with this mess tomorrow afternoon, okay? Yes, Inspector.” ")]), _vm._v(" "), _c('p', {
    staticClass: "textindent",
    attrs: {
      "xml:lang": "en-ca"
    }
  }, [_vm._v("He hung up without taking his eyes from the computer screen. He turned to the officer seated at the desk behind his. ")]), _vm._v(" "), _c('p', {
    staticClass: "textindent",
    attrs: {
      "xml:lang": "en-ca"
    }
  }, [_vm._v("“Hey Jacques, where’d the new inspector come from, Walmart?”")]), _vm._v(" "), _c('p', {
    staticClass: "textindent",
    attrs: {
      "xml:lang": "en-ca"
    }
  }, [_vm._v("Jacques Lapierre had been Nastos’ partner for two years. He was scrawny with black hair and spoke with a deep voice. He appeared one hundred percent native, although his mother was Irish. Jacques was promoted to detective at thirty-five for his work in the robbery unit and considered working sex crimes to be punishment. Hearing haunting stories of child abuse wasn’t his idea of a good time. ")]), _vm._v(" "), _c('p', {
    staticClass: "textindent",
    attrs: {
      "xml:lang": "en-ca"
    }
  }, [_vm._v("Jacques turned to meet Nastos, saying, “The guy’s half-retarded, Nastos. He belongs in the Safety Village.”")]), _vm._v(" "), _c('p', {
    staticClass: "textindent",
    attrs: {
      "xml:lang": "en-ca"
    }
  }, [_vm._v("“Can you come with me for a warrant? It won’t take long.”")]), _vm._v(" "), _c('p', {
    staticClass: "textindent",
    attrs: {
      "xml:lang": "en-ca"
    }
  }, [_vm._v("Jacques started closing off his computer and putting a few files away. “I’ve been itching to get out of this frigging place. I hate hockey. I’ll give Jen Baker a call; I’m sure she’d love to get out too.” ")]), _vm._v(" "), _c('p', {
    staticClass: "textindent",
    attrs: {
      "xml:lang": "en-ca"
    }
  }, [_vm._v("Nastos turned back to his phone and began dialling a number. “I’ll tell the roadies that we’re on the way.” Nastos spoke into the phone, “Hey Sarge, it’s Detective Nastos. Can your guys meet me a little earlier at the convenience store on James Street? Okay, see you then, thanks.”")]), _vm._v(" "), _c('p', {
    staticClass: "textindent",
    attrs: {
      "xml:lang": "en-ca"
    }
  }, [_vm._v("The noise coming from the hockey fans obscured the sound of Detective-Sergeant Koche approaching Nastos and Jacques’ work area. Koche like the first part of the word "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("kosher")]), _vm._v(". He resembled a somewhat taller and uglier Napoleon. He had penetrating blue eyes, made creepier by the fact that they bulged out of his head slightly. It likely wasn’t genetic, Nastos had decided. He probably developed it over time from being wound so tight. It was like a release valve and you could probably tell the barometric pressure in his head by measuring how far out they stuck at a particular time. When he got mad, he would stare in a way that was probably not supposed to be comical. Like all perfectionists, he was a micro-manager as well as imperfect. “Where the hell have you been?” he began.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("Nastos turned around and watched as he tried to puff his chest out. But with that shit-locker of an abdomen running at max capacity, it wasn’t very intimidating. ")]), _vm._v(" "), _c('p', {
    staticClass: "textindent",
    attrs: {
      "xml:lang": "en-ca"
    }
  }, [_vm._v("“I’m sorry, what did you say?” Nastos asked.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent",
    attrs: {
      "xml:lang": "en-ca"
    }
  }, [_vm._v("Jacques turned back to his desk and tried to put the show on of being both very busy and very invisible. “Here we go,” he muttered under his breath.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("“Listen, Nastos,” Koche began, “I had a conversation with Sergeant Lister not long ago. He said that he and a few of his guys had a warrant with you today, but that you two hadn’t talked yet. It’s unprofessional to leave him in the dark, don’t you think?”")]), _vm._v(" "), _c('p', {
    staticClass: "textindent",
    attrs: {
      "xml:lang": "en-ca"
    }
  }, [_vm._v("“It’s for an hour from now,” Nastos said, trying to hold back his anger. “I just got off the phone with him. It’s all under con —”")]), _vm._v(" "), _c('p', {
    staticClass: "textindent",
    attrs: {
      "xml:lang": "en-ca"
    }
  }, [_vm._v("“If it was under control, Nastos, I wouldn’t have to take your phone calls.” ")]), _vm._v(" "), _c('p', {
    staticClass: "textindent",
    attrs: {
      "xml:lang": "en-ca"
    }
  }, [_vm._v("Nastos slowly stood up, the backs of his knees pushing his chair back with a loud scrape. He took a slow deep breath, which was completely ineffective in calming him down, and clenched his hands tightly into white-knuckled fists. He considered whether this was finally the time to just beat the shit out of Koche and get it over with. With some people, there is just no talking and this goof was one of them. Nastos brought his face close to Koche’s, whose eyes became filled with a stupid wonder. ")]), _vm._v(" "), _c('p', {
    staticClass: "textindent",
    attrs: {
      "xml:lang": "en-ca"
    }
  }, [_vm._v("Koche did what Nastos expected: he flinched. He took a step back then a long slow gulp. Nastos noticed that although the sounds from the hockey game were still going on, the shouting and jeering from the spectators had stopped. All eyes had turned to him and Koche. ")]), _vm._v(" "), _c('p', {
    staticClass: "textindent",
    attrs: {
      "xml:lang": "en-ca"
    }
  }, [_vm._v("He strained to speak softly, barely controlled. “I don’t know what your problem is, Koche, but I’ve been doing this job since long before you got here and I’ll be doing it long after you’re gone. I don’t need to be micro-managed, so why don’t you just back off?” He looked directly into Koche’s eyes. ")]), _vm._v(" "), _c('p', {
    staticClass: "textindent",
    attrs: {
      "xml:lang": "en-ca"
    }
  }, [_vm._v("Koche’s face was flushed red. Veins stuck out on his neck and forehead and he did all he ever knew to do: he yelled. “You think you’re being micro-managed? No, you’re being babysat. There’s more to this job than arresting people; you have to treat people with courtesy and respect, especially superior officers. I could have you in the bicycle unit writing parking tickets by the end of the week, if you don’t smarten up.” ")]), _vm._v(" "), _c('p', {
    staticClass: "textindent",
    attrs: {
      "xml:lang": "en-ca"
    }
  }, [_vm._v("Nastos needed Koche to throw the first punch so he could respond in kind. “Is that an image that runs through your mind from time to time, me in tight bicycle shorts? Guess what I heard about you was right.”")]), _vm._v(" "), _c('p', {
    staticClass: "textindent",
    attrs: {
      "xml:lang": "en-ca"
    }
  }, [_vm._v("Koche screamed, “I can’t believe what you just said, Nastos.” ")]), _vm._v(" "), _c('p', {
    staticClass: "textindent",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("“Actually,” Nastos corrected, “it’s Detective Nastos, Detective-Sergeant Koche.” "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("That ought to do it. He’s going to throw the punch and pave the way for me.")])]), _vm._v(" "), _c('p', {
    staticClass: "textindent",
    attrs: {
      "xml:lang": "en-ca"
    }
  }, [_vm._v("Koche got to the level of frustration that he often reached and stammered a lame response. “Make sure "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Detectiv")]), _vm._v("e is on your resumé when you apply to the spca. And get the fuck out of the office.” ")]), _vm._v(" "), _c('p', {
    staticClass: "textindent",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("Koche turned and fumed out of the room. A dumbfounded wayward detective accidentally found himself in Koche’s path and was greeted with a cordial, “Move the fuck over,” as Koche shoved his way past.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent",
    attrs: {
      "xml:lang": "en-ca"
    }
  }, [_vm._v("Nastos noticed the faces in the office; shocked but not entirely surprised. A few detectives shook their heads as if to say, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Nastos, you’re playing with fire.")])]), _vm._v(" "), _c('p', {
    staticClass: "textindent",
    attrs: {
      "xml:lang": "en-ca"
    }
  }, [_vm._v("Jacques spoke as he stood up, grabbing his coat. “You know, you should probably chase him down and un-fuck yourself before it’s too late.”")]), _vm._v(" "), _c('p', {
    staticClass: "textindent",
    attrs: {
      "xml:lang": "en-ca"
    }
  }, [_vm._v("“It’s just not in me to suck ass. Who could possibly have any respect for that moron? Screw him.” ")]), _vm._v(" "), _c('p', {
    staticClass: "textindent",
    attrs: {
      "xml:lang": "en-ca"
    }
  }, [_vm._v("Jacques swung his coat on and locked his cabinets. “Nastos, if not because he’s our boss then maybe because he’s the Inspector’s puppy dog. The two of them can send you anywhere in the police service, you know that. And they hold grudges, Nastos; they’ll keep you on their naughty list till they get you. He’ll get you kicked out of here if you’re not careful.” ")]), _vm._v(" "), _c('p', {
    staticClass: "textindent",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("Nastos shrugged. “And get me away from child molesters and perverts? A big part of me thinks they’d be doing me a favour.” ")]), _vm._v(" "), _c('p', {
    staticClass: "textindent",
    attrs: {
      "xml:lang": "en-ca"
    }
  }, [_vm._v("They walked to the door, past the other detectives who rediscovered hockey. He overheard one snicker to another, “There goes Nasty Nastos,” followed by a few laughs. ")]), _vm._v(" "), _c('p', {
    staticClass: "textindent",
    attrs: {
      "xml:lang": "en-ca"
    }
  }, [_vm._v("Jacques ignored it and spoke quietly. “Nastos, see it from Dave’s point of view. One more promotion and he gets the company car, golf membership, probably even the ceremonial helmet with the antlers. If he identifies and corrects a problem employee, he looks like a hero. His rank can be dangerous.” ")]), _vm._v(" "), _c('p', {
    staticClass: "textindent",
    attrs: {
      "xml:lang": "en-ca"
    }
  }, [_vm._v("Nastos knew that Jacques was only trying to help. It only took the first week of working together for Nastos to figure out that Jacques was the most trustworthy partner that he’d ever had. “Well, my plan is to do my thing and soon enough he’ll get his promotion and some new blowhard will be here trying to make a name for himself so I can get a fresh start.” ")]), _vm._v(" "), _c('p', {
    staticClass: "textindent",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("“Well, as far as team building goes, you at least have style. Really, who goes up to their narcissist boss and implies that he’s gay in front of a squad of detectives?” ")]), _vm._v(" "), _c('p', {
    staticClass: "textindent",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("Nastos smiled. “Yeah, let’s get out of here. Maybe we can find the chief and call him a cross-dresser.”")]), _vm._v(" "), _c('p', {
    staticClass: "break",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_c('img', {
    staticClass: "generated-style",
    attrs: {
      "alt": "break.jpg",
      "src": "images/break.jpeg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "text",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_c('span', {
    staticClass: "small-caps"
  }, [_vm._v("NASTOS WALKED UP TO THE")]), _vm._v(" four uniformed officers who were standing in the parking lot of a convenience store, sipping coffees. It was barely above freezing with no snow on the ground. All of the cops were men: three were fairly young, in their twenties, and Sergeant Lister was at least thirty-five, well over six feet tall — a not-so-gentle giant of a man. Jen Baker and Jacques got out of their car and joined them. Jen was the best sexual assault officer he had ever heard of. At barely five feet tall, maybe 110 pounds, with long blond hair and a youthful face at thirty-two, Jen could connect with victims when other detectives failed. Standing near Sergeant Lister, she looked like a child herself. ")]), _vm._v(" "), _c('p', {
    staticClass: "textindent",
    attrs: {
      "xml:lang": "en-ca"
    }
  }, [_vm._v("Nastos smiled as he got close enough to address the officers. “Hey guys, thanks for coming early.” ")]), _vm._v(" "), _c('p', {
    staticClass: "textindent",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("“No problem, Nastos,” Lister said. ")]), _vm._v(" "), _c('p', {
    staticClass: "textindent",
    attrs: {
      "xml:lang": "en-ca"
    }
  }, [_vm._v("He began, “Okay, I know you’re busy, so I won’t waste too much of your time. I’ve got a copy of the warrant for everyone to read and sign.” Nastos passed it out. The officers signed it with barely a glance. Nastos continued, “Basically it’s an entry and arrest warrant. Page two is search and seizure. We want computer files, disks, camcorders and tapes and anything else like that. Dude’s name is Sean Harper; this is his picture.” Nastos passed out some photos. “You’ve all read the file. He works at a video rental store. He lives alone and has no kids of his own. He’s raped three kids who will go to trial and six that we know of who won’t.”")]), _vm._v(" "), _c('p', {
    staticClass: "textindent",
    attrs: {
      "xml:lang": "en-ca"
    }
  }, [_vm._v("Lister was the only one to speak. “Child molester, eh — he’s probably going to resist arrest, then I’m probably going to kick his ass.” A few of the officers exchanged smiles. Watching Lister jackhammer that special someone could be a thing of beauty.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent",
    attrs: {
      "xml:lang": "en-ca"
    }
  }, [_vm._v("Nastos had to try to give the appearance of wanting them to take it easy. “While I certainly can’t disagree with your thinking, sir, my name is going on the arrest report so if it’s all the same, I’d like to take this guy in all in one piece. Any questions?” They all shook their heads no, disappointed. ")]), _vm._v(" "), _c('p', {
    staticClass: "textindent",
    attrs: {
      "xml:lang": "en-ca"
    }
  }, [_vm._v("He could have confirmed the officer’s suspicion about the man becoming combative with police, could have said he’s resisted police before. It was part of policing jargon, the code words to say, “Beat him into a coma, I’ll fix the paperwork and buy you drinks after.” There were times when Nastos had given the pack of wolves the scent of blood, but not this time. With Koche’s eyes on him, he couldn’t take risks like trusting anyone except his partner, Jacques. ")]), _vm._v(" "), _c('p', {
    staticClass: "textindent",
    attrs: {
      "xml:lang": "en-ca"
    }
  }, [_vm._v("Nastos directed the last of the troops. “Detective Baker, you’re first one in the door.”")]), _vm._v(" "), _c('p', {
    staticClass: "textindent",
    attrs: {
      "xml:lang": "en-ca"
    }
  }, [_vm._v("“Sure thing, Nastos.” ")]), _vm._v(" "), _c('p', {
    staticClass: "textindent",
    attrs: {
      "xml:lang": "en-ca"
    }
  }, [_vm._v("“And you,” he pointed to a lanky rookie in the back with a nametag that read "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Post")]), _vm._v(". “Take the fastest guy from your shift here with you around back in case buddy bolts. The rest of you come up with me.” ")]), _vm._v(" "), _c('p', {
    staticClass: "textindent",
    attrs: {
      "xml:lang": "en-ca"
    }
  }, [_vm._v("Despite having one hundred percent confidence in Baker, Nastos still felt a certain amount of protectiveness for her. At her size, if Harper was going to make a stand Nastos would rather she not have front-row tickets to a brawl. But the shortest officer usually went in first so the guys back in the line could see what they were walking into. And she signed up for this job and never asked for special treatment, so he wasn’t going to offer her any. ")]), _vm._v(" "), _c('p', {
    staticClass: "break",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_c('img', {
    staticClass: "generated-style",
    attrs: {
      "alt": "break.jpg",
      "src": "images/break.jpeg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "text",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_c('span', {
    staticClass: "small-caps"
  }, [_vm._v("IT WAS A FOUR-STOREY BUILDING.")]), _vm._v(" The entire first floor was mixed commercial places: a Chinese food place, dry-cleaners and massage parlour. The elevator was too small to hold all of the cops so they wedged the door open to put it out of service, then took the stairs. The line of officers trudged up the winding staircase, led by Sergeant Lister and Detective Nastos. The smell of stale sweat and damp hung in the air. Nastos consciously avoided scraping against the walls, which were coated with a kind of filth best not contemplated. ")]), _vm._v(" "), _c('p', {
    staticClass: "textindent",
    attrs: {
      "xml:lang": "en-ca"
    }
  }, [_vm._v("Sergeant Lister read Nastos’ face. “You miss working on the road, Detective?” ")]), _vm._v(" "), _c('p', {
    staticClass: "textindent",
    attrs: {
      "xml:lang": "en-ca"
    }
  }, [_vm._v("“I miss kicking down doors; I don’t miss the shit-hole apartment part.” ")]), _vm._v(" "), _c('p', {
    staticClass: "textindent",
    attrs: {
      "xml:lang": "en-ca"
    }
  }, [_vm._v("“You got to take the good with the bad and the ugly.” Lister opened the door into the third floor hallway. ")]), _vm._v(" "), _c('p', {
    staticClass: "textindent",
    attrs: {
      "xml:lang": "en-ca"
    }
  }, [_vm._v("Nastos, Lister and the other officers took positions a few doors down from Harper’s apartment. Nastos keyed the mic to his radio and spoke to Post. “You in position at the back?” There was a pause. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Poor skinny kid’s likely looking for something to eat.")])]), _vm._v(" "), _c('p', {
    staticClass: "textindent",
    attrs: {
      "xml:lang": "en-ca"
    }
  }, [_vm._v("“It’s all ten-four on this end.” The radio crackled.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent",
    attrs: {
      "xml:lang": "en-ca"
    }
  }, [_vm._v("Jen crept up beside Nastos. They smiled dryly to each other. Nastos moved to the suspect’s door. They all withdrew their pistols, pointing them down to the floor. ")]), _vm._v(" "), _c('p', {
    staticClass: "textindent",
    attrs: {
      "xml:lang": "en-ca"
    }
  }, [_vm._v("The door had a walnut veneer with a peephole; it smelled of urethane and piss. Nastos knocked. “Pizza guy.” There was a noise, a movement. “Pizza guy,” he said again. “Hey pal, you want your pizza or not?” This time the movement sounded rushed, reckless. Glancing at the sergeant, Nastos whispered, “Someone’s in there screwing around,” then nodded sideways at the door. ")]), _vm._v(" "), _c('p', {
    staticClass: "textindent",
    attrs: {
      "xml:lang": "en-ca"
    }
  }, [_vm._v("Lister put his gun away and shouldered the door open. There was a loud crack as the jamb split followed by the thud of the door swinging into the back wall as the officers, led by Jen, exploded into the apartment shouting, “Police, search warrant!”")]), _vm._v(" "), _c('p', {
    staticClass: "textindent",
    attrs: {
      "xml:lang": "en-ca"
    }
  }, [_vm._v("Shouts of “Clear,” or “Nothing here,” came from the officers as they fanned out through the apartment. From a back room one of the uniform officer shouted, “Hands "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("up")]), _vm._v("! "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Get your hands up!")]), _vm._v("”")]), _vm._v(" "), _c('p', {
    staticClass: "textindent",
    attrs: {
      "xml:lang": "en-ca"
    }
  }, [_vm._v("Nastos turned from the back washroom and headed for the shouting officer. ")]), _vm._v(" "), _c('p', {
    staticClass: "textindent",
    attrs: {
      "xml:lang": "en-ca"
    }
  }, [_vm._v("Nastos recalled how people always say that responses to stress are either fight or flight. This, in his experience, was totally inaccurate. Anyone who has ever gone on YouTube and watched civilian responses to terrorist bombings, ever witnessed a car accident happen right in front of them, or even been startled by an evil niece or nephew from behind a door, never reacted by punching the first person they saw nor by running full speed in a random direction. No, what they do is what everyone actually does in such an instance: they freeze in place, staring wide-eyed, and in that time of hesitation police are trained to charge aggressively. ")]), _vm._v(" "), _c('p', {
    staticClass: "textindent",
    attrs: {
      "xml:lang": "en-ca"
    }
  }, [_vm._v("Harper was standing in a back laundry room with his hands over his head. As scared as he was, he was also pretty scary. Tall and broad with long greasy hair, forearms sleeved-out in faded prison ink — he almost certainly had hepatitis. Harper obviously hadn’t bathed in a few days and he stank of stale cigarettes. In fact, the whole apartment stank of stale smoke, Nastos now noticed. There was no need to check with the photo in his back pocket. ")]), _vm._v(" "), _c('p', {
    staticClass: "textindent",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("“Yeah, that’s him,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("“I think he tossed something out the window,” the officer said, not taking his eyes or gun from the man. Nastos shoved past Harper, pushing him against the wall, and peered out a small half-open window covered with a dingy blind. He keyed the mic to his radio again. “Hey, Post, you see anything fly out this window?” He stuck his hand out and waved it around.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent",
    attrs: {
      "xml:lang": "en-ca"
    }
  }, [_vm._v("Through the radio he heard Post say, “Yeah, some dvds and a memory stick. We’ll pick it up and meet you upstairs.” ")]), _vm._v(" "), _c('p', {
    staticClass: "textindent",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("Sergeant Lister walked into the small room. Having put away his gun, he had two hands free, so he grabbed Harper, turned him around 180 degrees and handcuffed him as painfully as he could. Harper made no effort to resist. His eyes were wide open, pupils as big as dinner plates. He was breathing quickly but was trying to slow himself down. ")]), _vm._v(" "), _c('p', {
    staticClass: "textindent",
    attrs: {
      "xml:lang": "en-ca"
    }
  }, [_vm._v("Harper’s voice cracked. “What the hell is this, who the fuck do you people think you are? You’ve got no right to come in my home like this —”")]), _vm._v(" "), _c('p', {
    staticClass: "textindent",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("“I don’t need to take any bullshit from a child molester,” Nastos interrupted. “If you had any brains at all you’d close that hole in your face till I read you your rights.” ")]), _vm._v(" "), _c('p', {
    staticClass: "textindent",
    attrs: {
      "xml:lang": "en-ca"
    }
  }, [_vm._v("Harper said, “You lay one hand on me and I’ll sue your ass off.” It wasn’t very convincing.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("Nastos turned to Lister. “On second thought, Sarge? Can one of your guys read this guy his rights in here? I want to have a look around.” ")]), _vm._v(" "), _c('p', {
    staticClass: "textindent",
    attrs: {
      "xml:lang": "en-ca"
    }
  }, [_vm._v("“Sure thing, Nastos.” Lister pointed to one of the officers, then followed Nastos out of the room. ")]), _vm._v(" "), _c('p', {
    staticClass: "textindent",
    attrs: {
      "xml:lang": "en-ca"
    }
  }, [_vm._v("They searched the apartment, going through cupboards, drawers, laundry baskets. Nastos went over everything again, this time searching jacket pockets in closets, the toilet tank, the freezer — everywhere idiots think you’re too dumb to check. When Jacques found that the home computer was turned off he unplugged it and started packing it up. “I love when we can take their stuff,” he said to Lister. “It’s just so satisfying.”")]), _vm._v(" "), _c('p', {
    staticClass: "textindent",
    attrs: {
      "xml:lang": "en-ca"
    }
  }, [_vm._v("Lister replied, “I’m happy enough just seeing their faces when we smash their shit to pieces right in front of them.” He smiled. ")]), _vm._v(" "), _c('p', {
    staticClass: "textindent",
    attrs: {
      "xml:lang": "en-ca"
    }
  }, [_vm._v("“Yeah, it must be how firemen feel when they rescue drunks with the jaws from fender benders.”")]), _vm._v(" "), _c('p', {
    staticClass: "textindent",
    attrs: {
      "xml:lang": "en-ca"
    }
  }, [_vm._v("Jen had a uniformed officer following her around as she took pictures with her digital camera. “Hey guys,” she called out to everyone, “continuity is key, gentlemen, so if you hit a jackpot, let me photograph what you found in place before you move anything. And who’s the rookie so I know who is getting screwed with the property reports?”")]), _vm._v(" "), _c('p', {
    staticClass: "textindent",
    attrs: {
      "xml:lang": "en-ca"
    }
  }, [_vm._v("An officer got Nastos’ attention. “Check this out here, Nastos, I think I’m going to puke.”")]), _vm._v(" "), _c('p', {
    staticClass: "textindent",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("Nastos walked into the room and found a cop flipping through Polaroids. Looking nauseous, he handed them over to Nastos. Nastos began flipping through the pictures, his hands moving slowly away from his face as he lost the strength to make himself go through any more pictures. It wasn’t long before he couldn’t bear it. His hands dropped down to his sides; he took a deep breath. He put all but one of the pictures in his jacket pocket. Nastos shouted to the officer with Harper.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent",
    attrs: {
      "xml:lang": "en-ca"
    }
  }, [_vm._v("The officer came into the living room, guiding the prisoner in front of him by the elbow. Nastos rotated the photograph he was holding so Harper could see it. ")]), _vm._v(" "), _c('p', {
    staticClass: "textindent",
    attrs: {
      "xml:lang": "en-ca"
    }
  }, [_vm._v("“Tell me who these guys are with you in this picture.”")]), _vm._v(" "), _c('p', {
    staticClass: "textindent",
    attrs: {
      "xml:lang": "en-ca"
    }
  }, [_vm._v("Harper evaded eye contact and ignored the picture. “No, I don’t know.” ")]), _vm._v(" "), _c('p', {
    staticClass: "textindent",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("Nastos moved closer to Harper, close enough that he had no choice but to look back at him. While there was every sign of fear, all Nastos saw was a deranged man. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("He probably tells himself that he really loves them")]), _vm._v(". ")]), _vm._v(" "), _c('p', {
    staticClass: "textindent",
    attrs: {
      "xml:lang": "en-ca"
    }
  }, [_vm._v("“Can you follow me while I take him down to my car, officer?” ")]), _vm._v(" "), _c('p', {
    staticClass: "textindent",
    attrs: {
      "xml:lang": "en-ca"
    }
  }, [_vm._v("“Sure thing, Nastos.” ")]), _vm._v(" "), _c('p', {
    staticClass: "textindent",
    attrs: {
      "xml:lang": "en-ca"
    }
  }, [_vm._v("“And can you ask Jacques to deal with things here?”")]), _vm._v(" "), _c('p', {
    staticClass: "textindent",
    attrs: {
      "xml:lang": "en-ca"
    }
  }, [_vm._v("“No probs, boss.” ")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3fc65c32","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CB_epub-2.vue
// module id = 69
// module chunks = 0